import React from "react";
import styled from "styled-components";
import { StyledA } from "../../../styles/StyledHTML";
const StyledAndOr = styled(StyledA)`
     &:after { display: none; }
`


export const AndOr = ({ value, onChange }) => {
    const handleChange = () => {
        if (value === 'OR') onChange('AND')
        else onChange('OR')
    }

    return (
        <StyledAndOr light small onClick={handleChange}>{value}</StyledAndOr>
    )
}